import * as React from 'react';
import { Dialog, Divider, Typography } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { CameraAlt, PhotoLibrary } from '@material-ui/icons';
import { ImageUtil } from '../util/ImageUtil';
import AlertDialog from './AlertDialog';
import * as Colors from './Colors';

interface Props {
    open: boolean
    onClose: () => void
    onFileSelected: (file: File) => void
}

function SlideUp(props: any) {
    return <Slide direction="up" {...props} />;
}

export default class ImageSourceDialog extends React.Component<Props> {
    private cameraInputRef = React.createRef<HTMLInputElement>();
    private galleryInputRef = React.createRef<HTMLInputElement>();

    private handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;
        const validation = ImageUtil.validateImageFile(files[0]);
        if (!validation.valid) {
            AlertDialog.show(validation.errorMessage || '');
            return;
        }
        this.props.onFileSelected(files[0]);
        this.props.onClose();
        e.target.value = '';
    }

    public render() {
        const { open, onClose } = this.props;

        return (
            <Dialog
                open={open}
                onClose={onClose}
                TransitionComponent={SlideUp}
                PaperProps={{
                    style: {
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        margin: 0,
                        width: '100%',
                        maxWidth: '100%',
                        borderRadius: '16px 16px 0 0',
                        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                        overflow: 'hidden',
                    }
                }}
                style={{ zIndex: 9999 }}
            >
                {/* Drag handle */}
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 12, paddingBottom: 4 }}>
                    <div style={{
                        width: 36,
                        height: 4,
                        borderRadius: 2,
                        backgroundColor: '#D0D0D8'
                    }} />
                </div>

                {/* Title */}
                <Typography style={{
                    textAlign: 'center',
                    fontWeight: 600,
                    fontSize: '1rem',
                    color: '#333',
                    paddingTop: 8,
                    paddingBottom: 16,
                }}>
                    画像の選択
                </Typography>

                <Divider />

                {/* Camera option */}
                <div
                    onClick={() => { if (this.cameraInputRef.current) this.cameraInputRef.current.click(); }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 16,
                        padding: '18px 28px',
                        cursor: 'pointer',
                        transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.background = '#F4F5F9'; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
                >
                    <div style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        backgroundColor: Colors.primaryColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <CameraAlt style={{ color: '#fff', fontSize: 22 }} />
                    </div>
                    <div>
                        <Typography style={{ fontWeight: 600, fontSize: '0.95rem', color: '#222' }}>カメラで撮影</Typography>
                        <Typography style={{ fontSize: '0.78rem', color: '#888', marginTop: 2 }}>カメラを起動して写真を撮影</Typography>
                    </div>
                </div>

                <Divider style={{ marginLeft: 88 }} />

                {/* Gallery option */}
                <div
                    onClick={() => { if (this.galleryInputRef.current) this.galleryInputRef.current.click(); }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 16,
                        padding: '18px 28px',
                        cursor: 'pointer',
                        transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.background = '#F4F5F9'; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
                >
                    <div style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        backgroundColor: '#5B9BD5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <PhotoLibrary style={{ color: '#fff', fontSize: 22 }} />
                    </div>
                    <div>
                        <Typography style={{ fontWeight: 600, fontSize: '0.95rem', color: '#222' }}>ギャラリーから選択</Typography>
                        <Typography style={{ fontSize: '0.78rem', color: '#888', marginTop: 2 }}>フォトライブラリから画像を選択</Typography>
                    </div>
                </div>

                <Divider />

                {/* Cancel */}
                <div
                    onClick={onClose}
                    style={{
                        textAlign: 'center',
                        padding: '16px',
                        cursor: 'pointer',
                        transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.background = '#F4F5F9'; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
                >
                    <Typography style={{ fontWeight: 600, color: '#888', fontSize: '0.95rem' }}>キャンセル</Typography>
                </div>

                {/* Hidden inputs */}
                <input
                    ref={this.cameraInputRef}
                    type="file"
                    accept={ImageUtil.getAcceptAttribute()}
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={this.handleFile}
                />
                <input
                    ref={this.galleryInputRef}
                    type="file"
                    accept={ImageUtil.getAcceptAttribute()}
                    style={{ display: 'none' }}
                    onChange={this.handleFile}
                />
            </Dialog>
        );
    }
}
